<template>
    <svg height="16.682" viewBox="0 0 12.975 16.682" width="12.975" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Icon_material-delete-forever"
            d="M8.427,19.328a1.859,1.859,0,0,0,1.854,1.854h7.414a1.859,1.859,0,0,0,1.854-1.854V8.207H8.427Zm2.28-6.6,1.307-1.307,1.974,1.965,1.965-1.965,1.307,1.307-1.965,1.965,1.965,1.965-1.307,1.307L13.987,16l-1.965,1.965-1.307-1.307,1.965-1.965Zm6.525-7.3L16.3,4.5H11.67l-.927.927H7.5V7.28H20.475V5.427Z"
            data-name="Icon material-delete-forever"
            fill="#f64e60"
            transform="translate(-7.5 -4.5)"
        />
    </svg>
</template>

<script>
export default {
    name: "ActionDelete",
};
</script>
